export default "__VITE_ASSET__lfDCZ4Gj__"